import {
  FundraisingModel,
  FundraisingTicketingInfo,
  SendTicket,
  Step,
  TABS,
} from 'src/models/FundraisingModel';
import { FundraisingProps, renderHasChanged } from 'src/components/Pages/AddFundraisingPage';
import Button from '@material-ui/core/Button';
import { MouseEvent, useEffect, useState } from 'react';
import { useAppDispatch } from 'src/redux/Store';
import { FORM } from 'src/constants/Form';
import { setError } from 'src/redux/actions/errorsActions';
import FormCheckbox from 'src/components/Control/FormControls/FormCheckbox';
import Subtitle from 'src/components/UI/Subtitle';
import BottomRow from 'src/components/UI/BottomRow';
import FundraiserTitle from 'src/components/UI/FundRaiserTitle';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import FormTextField from 'src/components/Control/FormControls/FormTextField';
import Row from 'src/components/UI/Row';
import FormDateTimePicker from 'src/components/Control/FormControls/FormDateTimePicker';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import moment from 'moment-timezone-all';
import Scroller from 'src/components/UI/Scroller';

const FundraisingTicketingForm = (props: FundraisingProps) => {
  const {
    onChange,
    setErrors,
    fundraisingState,
    setHasChanged,
    hasChanged,
  } = props;
  const dispatch = useAppDispatch();

  const getInitialTicketingState = (): FundraisingTicketingInfo => {
    if (fundraisingState?.ticketingInfo) {
      return { ...fundraisingState.ticketingInfo };
    }
    return {
      ticket_send_mode: SendTicket.all,
    } as FundraisingTicketingInfo;
  };

  const [ticketingState, setTicketingState] = useState<FundraisingTicketingInfo>(
    getInitialTicketingState(),
  );

  const [openTicketing, setOpenTicketing] = useState(
    !!fundraisingState?.ticketingInfo?.title
    || !!fundraisingState?.ticketingInfo?.location_name,
  );

  useEffect(() => {
    if (!fundraisingState.ticketingInfo) return;
    setTicketingState({ ...fundraisingState.ticketingInfo });
  }, [fundraisingState]);

  useEffect(() => {
    dispatch(setError({ [FORM.fundraisingProducts]: {} }));
  }, []);

  const onTicketValueChange = (value: any, field: string) => {
    setHasChanged(true);
    setTicketingState({
      ...ticketingState,
      [field]: value,
    });
  };

  const handleSubmit = (event: MouseEvent<HTMLElement>, advance: boolean) => {
    event.preventDefault();
    setErrors(TABS.ticketing, false);
    dispatch(setError({ [FORM.fundraisingProducts]: {} }));

    onChange(
      {
        ...fundraisingState,
        ticketingInfo: openTicketing ? ticketingState : null,
      } as FundraisingModel,
      Step.ticketing,
      advance,
    );
  };

  return (
    <>
      <FundraiserTitle>Ticketing</FundraiserTitle>
      <Scroller height="565px">
        <Subtitle>Ticketing</Subtitle>
        <Row>
          <FormCheckbox
            checked={openTicketing}
            label="Ticketing Information"
            name="ticketing_information"
            onChange={(value: boolean) => setOpenTicketing(value)} />
        </Row>
        {openTicketing && (
          <>
            <Row>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="ticket_send_mode"
                  name="ticket_send_mode"
                  value={ticketingState.ticket_send_mode}
                  onChange={(e: any, value: string) => onTicketValueChange(value, 'ticket_send_mode')}>
                  <FormControlLabel
                    value={SendTicket.none}
                    control={<Radio />}
                    label="Do not send ticket" />
                  <FormControlLabel
                    value={SendTicket.all}
                    control={<Radio />}
                    label="Send all ticket in one PDF" />
                  <FormControlLabel
                    value={SendTicket.separate}
                    control={<Radio />}
                    label="Send each ticket in a separate PDF" />
                </RadioGroup>
              </FormControl>
            </Row>
            <Row>
              <div style={{ width: '75%' }}>
                <FormTextField
                  form={FORM.fundraisingProducts}
                  label="Name of the event"
                  name="title"
                  onChange={onTicketValueChange}
                  value={ticketingState.title} />
              </div>
              <div style={{ width: '25%' }}>
                <FormDateTimePicker
                  form={FORM.fundraisingInfo}
                  label="Event date"
                  name="event_date"
                  onChange={
                    (value: MaterialUiPickersDate) => onTicketValueChange(value, 'event_date')
                  }
                  value={ticketingState.event_date || moment()
                    .add(1, 'day')
                    .startOf('day')}
                  minDate={moment()
                    .add(1, 'day')
                    .startOf('day')}
                  showTime />
              </div>
            </Row>
            <Row>
              <div style={{ width: '75%' }}>
                <FormTextField
                  form={FORM.fundraisingProducts}
                  label="Location Name"
                  name="location_name"
                  onChange={onTicketValueChange}
                  value={ticketingState.location_name} />
              </div>
            </Row>
            <Row>
              <div style={{ width: '75%' }}>
                <FormTextField
                  form={FORM.fundraisingProducts}
                  label="Location Address"
                  name="location_address"
                  onChange={onTicketValueChange}
                  value={ticketingState.location_address} />
              </div>
            </Row>
            <Row>
              <div style={{ width: '75%' }}>
                <FormTextField
                  form={FORM.fundraisingProducts}
                  label="Contact name"
                  name="contact_name"
                  onChange={onTicketValueChange}
                  value={ticketingState.contact_name} />
              </div>
            </Row>
            <Row>
              <div style={{ width: '50%' }}>
                <FormTextField
                  form={FORM.fundraisingProducts}
                  label="Contact phone"
                  name="contact_phone"
                  onChange={onTicketValueChange}
                  value={ticketingState.contact_phone} />
              </div>
              <div style={{ width: '50%' }}>
                <FormTextField
                  form={FORM.fundraisingProducts}
                  label="Contact email"
                  name="contact_email"
                  onChange={onTicketValueChange}
                  value={ticketingState.contact_email} />
              </div>
            </Row>
            <Row>
              <div style={{ width: '100%' }}>
                <FormTextField
                  form={FORM.fundraisingProducts}
                  label="Ticket message"
                  name="ticket_message"
                  onChange={onTicketValueChange}
                  value={ticketingState.ticket_message} />
              </div>
            </Row>
          </>
        )}
        <BottomRow>
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => handleSubmit(e, false)}
            key="submit-button">
            Save{renderHasChanged(!hasChanged)}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => handleSubmit(e, true)}
            key="submit-button-next">
            Save{renderHasChanged(!hasChanged)} and Next Step
          </Button>
        </BottomRow>
      </Scroller>
    </>
  );
};

export default FundraisingTicketingForm;
